import { Injectable } from "@angular/core";
import { SharingService } from "./dataSharing.services";
import { ThemesService } from "./themes.service";


export interface ILayoutConf{
    backgroundColor?: string;
    color?: string;
    textSize?: string;
}

@Injectable({
  providedIn: "root"
})
export class LayoutService{

public layoutConf: ILayoutConf;

    constructor(private themeService: ThemesService, private localeService: SharingService){
        this.init();
    }

    init(){
        if(this.localeService.config){
            this.setAppLayout(this.localeService.config);
        } else {
          this.setAppLayout(this.getDefaultLayout());
        }
    }

    getDefaultLayout(){
        const defaultSettings = {
            backgroundColor: "white",
            color: "fontBlack",
            textSize: "medium"
        }
        return defaultSettings;
    }

    publishBackgroundChange(lc: ILayoutConf){
        if(this.layoutConf.backgroundColor !== lc.backgroundColor){
            this.themeService.applyTheme(this.layoutConf.backgroundColor, lc.backgroundColor);             
        }            
        this.layoutConf.backgroundColor = lc.backgroundColor;
        this.localeService.config = this.layoutConf
    }

    publishSizeChange(lc: ILayoutConf) {
        if(this.layoutConf.textSize !== lc.textSize){
            this.themeService.applyTheme(this.layoutConf.textSize, lc.textSize);  
        }            
        this.layoutConf.textSize = lc.textSize;
        this.localeService.config = this.layoutConf
        }

    publishTextChange(lc: ILayoutConf){
        if(this.layoutConf.color !== lc.color){
            this.themeService.applyTheme(this.layoutConf.color, lc.color);             
        }            
        this.layoutConf.color = lc.color;
        this.localeService.config = this.layoutConf
    }

    setAppLayout(layoutConf: ILayoutConf){
        this.layoutConf = {...this.layoutConf, ...layoutConf};
        this.applybgColor();
        this.applyFontSizeColor();
        this.applyTextColor();
    }

    applybgColor(){
        this.themeService.applyConfig(this.layoutConf.backgroundColor);
    }
    applyTextColor(){
        this.themeService.applyConfig(this.layoutConf.color);
    }
    applyFontSizeColor(){
        this.themeService.applyConfig(this.layoutConf.textSize);
    }

}